module.exports = __webpack_public_path__ + "img/carte-st-jacques.5da359ec.png";